import api from './api';

export async function login(corporate_email, password) {
  // aqui você chama sua rota real de login da API Laravel
  const response = await api.post('/login', { corporate_email, password});
  return response.data;
}

export async function logout() {
  const response = await api.post('/logout');
  return response.data;
}

export async function getCurrentUser() {
  const response = await api.get('/users/me');
  return response.data;
}

export async function updateTheme(theme) {
  const response = await api.patch('/users/me/theme', { theme });
  return response.data;
}

const authService = { login, logout, getCurrentUser, updateTheme };
export default authService;

